// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3a0ae4cf6365399e93a1","655":"8abd19d845ef1ce8b017"}[chunkId] + ".js";
};